import { useContext, useMemo } from 'react';
import {
  Card,
  DatePeriodTypesEnum,
  FilterContext,
  Flex,
  Icon,
  Spinner,
  Text,
  getPeriodRangeByPeriodType,
} from 'dash-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { useGetCurrentDeveloperPropertiesQuery, useGetPropertyViewsByBrokerQuery } from 'gql/generated.graphql';

import ViewedByAgentsChart from './components/ViewedByAgentsChart';

const ViewedByAgentsWidget = () => {
  const theme = useTheme();
  const { t } = useTranslation('pages');
  const { state: filterState } = useContext(FilterContext);

  const { data: dataProperies, loading: loadingProperties } = useGetCurrentDeveloperPropertiesQuery();

  const { properties } = useMemo(() => ({
    properties: dataProperies?.getCurrentDeveloperProperties.collection || [],
  }), [dataProperies]);

  const { data, loading } = useGetPropertyViewsByBrokerQuery({
    variables: {
      filter: {
        propertyIds: properties.map((p) => p._id),
        range: filterState.dateRange
          ? {
              startDate: filterState?.dateRange?.startDate,
              endDate: filterState?.dateRange?.endDate,
            }
          : getPeriodRangeByPeriodType(DatePeriodTypesEnum.CURRENT_WEEK),
      },
      pagination: {
        allowLimit: false,
      }
    },
  });

  const agentViews = useMemo(
    () => data?.getPropertyViewsByBroker.collection || [],
    [data]
  );

  return (
    <Card p={4} flexDirection="column" minHeight={321} my={4} pos="relative">
      <Text semibold lg>
        {t('organizationDashboardPage.viewedByAgents')}
      </Text>
      {agentViews.length > 0 ? (
        <ViewedByAgentsChart data={agentViews} />
      ) : (
        <Flex w="100%" alignItems="center" justifyContent="center" flex={1}>
          <Flex>
            <Icon
              name="presentation"
              size={82}
              color={theme.colors.b30}
              mr={6}
            />
            <Text semibold lg>
              {data?.getPropertyViewsByBroker.totalCount === 0
                ? t('organizationDashboardPage.viewedByAgentsNoResult')
                : t('organizationDashboardPage.viewedByAgentsPlaceholderTitle')}
            </Text>
          </Flex>
        </Flex>
      )}
      {loading && loadingProperties && <Spinner fullContent />}
    </Card>
  );
};

export default ViewedByAgentsWidget;
